import { render } from "./Footer.vue?vue&type=template&id=e455ace6&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=e455ace6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e455ace6"]])

export default __exports__